import { informationTableClasses, InformationTableVariants } from './InformationTable.css'
import { PortableTextObject } from 'sanity'
import { InformationRows } from '../InformationRows/InformationRows'
import { SectionHeader } from "../../SectionHeader"

interface InformationTableProps extends InformationTableVariants {
	tag: string
	title: PortableTextObject
	description: PortableTextObject
	table: any[]
}

export const InformationTable: React.FC<InformationTableProps> = ({
	tag,
	title,
	description,
	table,
}) => {
	const { base } = informationTableClasses()

	return (
		<section className={base()}>
			<SectionHeader tag={tag} title={title} description={description} />
			<InformationRows table={table} />
		</section>
	)
}
